import { useState } from "react";
import { clock, closeButtonDark, rightArrow, smallArrow } from "./svgs";

interface MarketCurrencySelectorProps {
  currencyEstimates: [
    {
      symbol: string;
      name: string;
      exhangeRate: number;
    }
  ];
  currencies: string[];
  currency: string;
  setCurrency: (currency: string) => void;
  seconds: number;
}

const bubbleStyles: React.CSSProperties = {
  position: "relative",
  background: "#ede6ff",
  borderRadius: "8px",
  padding: "10px",
  paddingTop: "12px",
  paddingBottom: "12px",
  marginRight: "20px",
  fontSize: "12px",
  cursor: "pointer",
  color: "rgba(133, 78, 251, 1)",
};

const tailStyles: React.CSSProperties = {
  position: "absolute",
  width: "0",
  height: "0",
  borderTop: "5px solid transparent",
  borderBottom: "5px solid transparent",
  borderLeft: "10px solid rgba(133, 78, 251, 0.1)",
  top: "50%",
  right: "-10px",
  transform: "translateY(-50%)",
};

const MarketCurrencySelector: React.FC<MarketCurrencySelectorProps> = ({
  currencyEstimates,
  currency,
  currencies,
  setCurrency,
  seconds,
}) => {
  const [menu, setMenu] = useState<boolean>(false);

  var widthStyle = "100%"

  if (navigator.userAgent.includes("Firefox")) {
    widthStyle = "-moz-available";
  } else if (
    navigator.userAgent.includes("Chrome") ||
    navigator.userAgent.includes("Safari")
  ) {
    widthStyle = "-webkit-fill-available";
  } else {
    widthStyle = "fill-available";
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      {currency == "USD" && (
        <div style={bubbleStyles} onClick={() => setMenu(true)}>
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "row",
              gap: 6,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                width: 38,
              }}
            >
              <img
                src={require(`../../images/coins/${"LTC".toLowerCase()}.svg`)}
                width={15}
                height={15}
                style={{
                  left: 20,
                  position: "absolute",
                  borderRadius: "100px",
                  border: "1px solid #ede6ff",
                }}
              ></img>
              <img
                src={require(`../../images/coins/${"ETH".toLowerCase()}.svg`)}
                width={15}
                height={15}
                style={{
                  left: 10,
                  position: "absolute",
                  borderRadius: "100px",
                  border: "1px solid #ede6ff",
                }}
              ></img>
              <img
                src={require(`../../images/coins/${"BTC".toLowerCase()}.svg`)}
                width={15}
                height={15}
                style={{
                  left: 0,
                  position: "absolute",
                  borderRadius: "100px",
                  border: "1px solid #ede6ff",
                }}
              ></img>
            </div>
            {"Switch to Crypto"}
          </div>
          <div style={tailStyles}></div>
        </div>
      )}
      {currency != "USD" && (
        <div
          style={{
            display: "flex",
            fontSize: "12px",
            alignContent: "center",
            alignItems: "center",
            color: "rgba(0, 0, 0, 0.7)",
            paddingRight: 25,
            gap: 5,
          }}
        >
          {clock} Quotes update in <span style={{ width: 5 }}>{seconds}s</span>
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          alignContent: "center",
          background: "rgba(0, 0, 0, 0.05)",
          padding: "6px 8px 6px 8px",
          borderRadius: 8,
          height: 20,
          cursor: "pointer",
          gap: 5,
        }}
        onClick={() => {
          setMenu(true);
        }}
      >
        {currency}
        {smallArrow}
      </div>
      {menu && (
        <div
          style={{
            position: "absolute",
            display: 'flex',
            top: 0,
            left: 0,
            background: "#00000080",
            width: widthStyle,
            height: "100%",
            overflow: "hidden",
            zIndex: 1,
            cursor: "pointer",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center",
          }}
          onClick={() => {
            setMenu(false);
          }}
        >
          <div
            style={{
              position: "relative",
              display: 'flex',
              flexDirection: 'column',
              height: "100%",
              width: widthStyle,
              background: "#FFFFFF",
              maxHeight: "500px",
              maxWidth: "350px",
              borderRadius: "24px",
              overflow: "hidden",
              zIndex: 2,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "20px",
                alignContent: "center",
                alignItems: "center",
                fontSize: "20px",
              }}
            >
              Currency
              <button
                onClick={() => {
                  setMenu(false);
                }}
                style={{
                  justifyContent: "center",
                  cursor: "pointer",
                  alignItems: "center",
                  paddingTop: 4,
                  width: 32,
                  height: 32,
                  background: "rgba(0, 0, 0, 0.05)",
                  borderRadius: 12,
                  border: "none",
                  color: "#000000",
                }}
              >
                {closeButtonDark}
              </button>
            </div>

            <div
              style={{
                paddingRight: "20px",
                paddingLeft: "20px",
                paddingBottom: "20px",
                borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                overflow: "scroll",
                height: "90%",
                maxHeight: "500px",
              }}
            >
              <div
                style={{
                  overflow: "scroll",
                }}
              >
                {currencyEstimates
                  .filter(({ symbol }) => symbol.toUpperCase() != currency)
                  .filter(
                    ({ symbol }) =>
                      currencies.includes(symbol.toUpperCase()) ||
                      symbol.toUpperCase() == "USD"
                  )
                  .map(({ symbol, name }) => {
                    // TODO: Change USDT20 display name to satisfy the boss.
                    if (symbol == "USDT20") {
                      symbol = "USDT";
                      name = "Tether";
                    }

                    return (
                      <div
                        key={`${symbol}-currency`}
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                          paddingTop: "20px",
                          paddingBottom: "20px",
                          fontSize: "16px",
                          display: "flex",
                          flexDirection: "row",
                          alignContent: "center",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setCurrency(symbol.toUpperCase());
                          setMenu(false);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 10,
                            alignItems: "center",
                            alignContent: "center",
                          }}
                        >
                          {symbol.toUpperCase() == "USD" && (
                            <div
                              style={{
                                width: 30,
                                height: 30,
                                borderRadius: "100px",
                                border: "1px solid #ede6ff",
                                fontSize: "14px",
                                alignContent: "center",
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                                background: "#73738c",
                                color: "#FFFFFF",
                              }}
                            >
                              {getCurrencySymbol("US", "USD")}
                            </div>
                          )}
                          {symbol.toUpperCase() != "USD" && (
                            <img
                              src={require(`../../images/coins/${symbol.toLowerCase()}.svg`)}
                              width={30}
                              height={30}
                              style={{
                                borderRadius: "100px",
                                border: "1px solid #ede6ff",
                              }}
                            ></img>
                          )}
                          <div>{name}</div>
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 20,
                          }}
                        >
                          {symbol.toUpperCase()}
                          {rightArrow("black")}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const getCurrencySymbol = (locale: string, currency: string) =>
  (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: "narrowSymbol",
    })
    .replace(/\d/g, "")
    .trim();

export default MarketCurrencySelector;
